import axios from 'axios';
import type {
  User,
  UserOnboardingStep,
  UserRole,
  UserStatus,
  UserZoneOfSearch,
  UserWishedJob,
  WishedContractType,
  ROMEJob,
} from '@addviseo/shared/types';

export interface FullUserData extends User {
  wishedJobs: (UserWishedJob & { romeJob?: ROMEJob })[];
  zonesOfSearch: (UserZoneOfSearch & { city?: { inseeCode: string; name: string } })[];
  wishedContractType: WishedContractType | null;
}

export interface UpdateUserPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string | null;
  role?: UserRole;
  status?: UserStatus;
  onboardingStep?: UserOnboardingStep;
  address?: string | null;
  cityName?: string | null;
  zipCode?: string | null;
  gcuAccepted?: Date | null;
}

export interface UpdateWishedContractsPayload {
  apprenticeship: boolean;
  fixedTerm: boolean;
  permanent: boolean;
  temporary: boolean;
  seasonal: boolean;
  internship: boolean;
}

export const getFullUser = () => {
  return axios.get<FullUserData>('/api/devtools/user').then((response) => response.data);
};

export const updateUser = (data: UpdateUserPayload) => {
  return axios
    .post<{ code: string; user: User }>('/api/devtools/user', data)
    .then((response) => response.data);
};

export const updateWishedContracts = (data: UpdateWishedContractsPayload) => {
  return axios
    .post<{ code: string }>('/api/devtools/user/wished-contracts', data)
    .then((response) => response.data);
};

export const generateMagicLink = (redirectUrl: string) => {
  return axios
    .post<{ magicLink: string; expirationDate: string }>('/api/devtools/magic-link', {
      redirectUrl,
    })
    .then((response) => response.data);
};

export default {
  getFullUser,
  updateUser,
  updateWishedContracts,
  generateMagicLink,
};
